module.exports = __webpack_public_path__ + "img/banner-princiapal.84b4a565.png";